import { FaClock, FaCheckCircle } from "react-icons/fa";
import "./style.scss";

const LearningPathCard = ({ title, duration, modules, learn, features }) => {
  return (
    
      <div className="rounded-lg border  shadow-sm bg-dark-secondary border-primary hover-card cursor-pointer h-100">
        <div className="p-4">
          {/* Title */}
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h5 className="fw-bold text-light">{title}</h5>
          </div>

          {/* Duration */}
          <div className="mb-3">
            <small className="text-light d-flex align-items-center">
              <FaClock size={14} className="me-1" />
              {duration} • {modules} modules
            </small>
          </div>

          {/* Learn Section */}
          <div className="mb-3">
            <h6 className="text-light mb-2">What you'll learn:</h6>
            <div className="d-flex flex-wrap gap-1">
              {learn.map((item, index) => (
                <span key={index} className="badge bg-primary small">
                  {item}
                </span>
              ))}
            </div>
          </div>

          {/* Features Section */}
          <div className="mb-3">
            <h6 className="text-light mb-2">Features included:</h6>
            {features.map((feature, index) => (
              <div key={index} className="d-flex align-items-center mb-1">
                <FaCheckCircle size={14} className="text-accent me-2" />
                <small className="text-light">{feature}</small>
              </div>
            ))}
          </div>
        </div>
      </div>
   
  );
};

export default LearningPathCard;